import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../keys";
import { queryApi } from "../api";
import { getTokens } from "../../utils/tokens";

const SUBSCRIPTION_PLANS_STALE_MS = 60 * 1000;

export function useSubscriptionPlansQuery() {
  const hasToken = !!getTokens()?.access_token;

  return useQuery({
    queryKey: queryKeys.subscriptionPlans,
    queryFn: queryApi.fetchMySubscriptionPlans,
    enabled: hasToken,
    staleTime: SUBSCRIPTION_PLANS_STALE_MS,
  });
}
